import { getObjectListByPropertyApi, putUpdateObjectListByPropertyValueArrayApi } from "api/general";
import { sortByProperty } from "app/utils/appHelpers";
import { DECISION, REVIEWS, VOTE } from "app/utils/constants/customConstant";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentAgendaList, setCurrentMeetingReviewList, setCurrentMeetingVoteList } from "stores/meeting";
import AgendaContainer from "../Container/AgendaContainer";

function MeetingAgendaTab() {
    const dispatch = useDispatch();

    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const [loading, setLoading] = useState(true);
    const [agendaList, setAgendaList] = useState([]);
    const userList = useSelector(state => state.user.data || []);
    const currentMeetingReviewList = useSelector(state => state.meeting.currentMeetingReviewList);
    const currentMeetingVoteList = useSelector(state => state.meeting.currentMeetingVoteList);
    const currentAgendaList = useSelector(state => state.meeting.currentAgendaList);
    const currentMeetingUsers = useSelector(state => state.meeting.currentMeetingUsers);
    useEffect(() => {
        const getAPI = async () => {
            setLoading(true);

            try {
                if (currentAgendaList !== undefined && currentAgendaList.length === 0) {
                    const resultMeetingAgendas = await getObjectListByPropertyApi(DECISION, "meetingId", currentMeeting.id);
                    let data = resultMeetingAgendas.data

                    data.forEach(item => {
                        const user = userList.find(x => x.id === item.adminUserId)
                        item.user = user
                    });
                    data = sortByProperty(data, "decisionNo");
                    setAgendaList(data)
                    dispatch(setCurrentAgendaList([...data]));
                }

                if (currentMeetingReviewList === null) {
                    const resultMeetingReviews = await getObjectListByPropertyApi(REVIEWS, "meetingId", currentMeeting.id);
                    let dataReview = resultMeetingReviews.data

                    dataReview = dataReview.map(item => {
                        const user = userList.find(x => x.id === item.userId);
                        const meetingUser = currentMeetingUsers.find(x => x.userId === item.userId);
                        return {
                            ...item,
                            user: user,
                            indexNo: meetingUser ? meetingUser.indexNo : Number.MAX_SAFE_INTEGER
                        };
                    });

                    dataReview.sort((a, b) => a.indexNo - b.indexNo);
                    dispatch(setCurrentMeetingReviewList([...dataReview]));
                }


                if (currentMeetingVoteList === null) {

                    const resultMeetingVotes = await getObjectListByPropertyApi(VOTE, "meetingId", currentMeeting.id);
                    let dataVotes = resultMeetingVotes.data

                    dataVotes.forEach(item => {
                        const user = userList.find(x => x.id === item.userId)
                        item.user = user
                    });
                    dispatch(setCurrentMeetingVoteList([...dataVotes]));

                }

            } catch (error) {
                // console.log("Error", error)
                setLoading(false)
            } finally {
                setLoading(false)

            }

        }

        getAPI()
    }, [currentMeeting]);

    const sortingAfterData = async (sortedData) => {
        sortedData = sortedData.map((item, idx) => ({
            ...item,
            decisionNo: idx + 1,
        }));
        const objectList = sortedData.map(({ id, decisionNo }) => ({ id, decisionNo }));
        const result = await putUpdateObjectListByPropertyValueArrayApi(DECISION, "decisionNo", objectList);

        if (result.status) {
            setAgendaList([...sortedData]);
            dispatch(setCurrentAgendaList([...sortedData]));
        }
    };



    return (
        <div>
            {
                <AgendaContainer loading={loading} >
                </AgendaContainer>
            }

        </div>
    );
}

export default MeetingAgendaTab;